'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:loginCtrl
 * @description
 * # loginCtrl
 * Controller of the myConsultApp
 */
angular.module('myConsultApp').controller('loginCtrl', function ($scope, $rootScope, UserService) {
  if (UserService.isValid()) {
    return UserService.redirectUser();
  }
  $rootScope.clearData();
});
